angular.module('bmsApp.reports')
	.controller('ReportMmWeeklyIncomeCtrl', [
		'$scope',
		function ($scope) {

			// get categories from the forecast
			var revenueDates = [];
			angular.forEach($scope.ReportIndex.selectedReport.reportData.forecast_revenue, function (row) {
				// format as day of week (if monday include date)
				var dateMoment = moment(row.date);
				if (dateMoment.weekday() === 0) {
					revenueDates.push(dateMoment.format('ddd DD/MM/YYYY'));
				}
				else {
					revenueDates.push(dateMoment.format('ddd'));
				}
			});
			// get the data from both series
			var forecastSeries = [];
			angular.forEach($scope.ReportIndex.selectedReport.reportData.forecast_revenue, function (row) {
				forecastSeries.push(row.forecast_revenue);
			});
			var actualSeries = [];
			angular.forEach($scope.ReportIndex.selectedReport.reportData.actual_revenue, function (row) {
				actualSeries.push(row.actual_revenue);
			});
			var forecastFromDate = moment($scope.ReportIndex.selectedReport.reportData.dates.forecast.from).format($scope.config.format.date.amMediumDate);
			var forecastToDate = moment($scope.ReportIndex.selectedReport.reportData.dates.forecast.to).format($scope.config.format.date.amMediumDate);
			var comparisonFromDate = moment($scope.ReportIndex.selectedReport.reportData.dates.comparison.from).format($scope.config.format.date.amMediumDate);
			var comparisonToDate = moment($scope.ReportIndex.selectedReport.reportData.dates.comparison.to).format($scope.config.format.date.amMediumDate);
			var subTitle = "Between " + forecastFromDate + ' - ' + forecastToDate +
				"<br>" +
				"Compared to weeks between " + comparisonFromDate + ' - ' + comparisonToDate;
			$scope.charts = {
				revenue: {
					title: {
						text: 'Forecasted Revenue'
					},
					subtitle:{
						text: subTitle,
						style: {
							color: '#aaa'
						}
					},
					credits: false,
					xAxis: [{
						categories: revenueDates
					}],
					yAxis: [{
						labels: {
							format: '£{value}'
						},
						title: {
							text: 'Revenue'
						}
					}],
					tooltip: {
						valuePrefix: '£'
					},
					series: [{
						type: 'column',
						name: 'Forecast',
						color: '#7ABE43',
						data: forecastSeries
					}, {
						type: 'spline',
						name: 'Actual Revenue',
						data: actualSeries,
						color: 'gray',
						lineWidth: 4,
						marker: {
							lineWidth: 3,
							lineColor: 'orange',
							fillColor: 'white'
						}
					}]
				}
			};
			$scope.chartObjs = {};

		}
	]);
